import { observer } from 'mobx-react-lite';
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Button, Container, Dropdown, Icon, Image, Menu } from 'semantic-ui-react';
import { useStore } from '../stores/store';

// interface Props {
//     openForm: () => void;
// }

const styles = { //. x
    fontSize: 15,
    fontWeight: 'bold', 
};

//export default function NavBar({openForm} : Props) {
//export default function NavBar() {
export default observer(function NavBar() {

    //const {activityStore, commonStore, userStore: {user, logout, isLoggedIn}} = useStore(); //' n
    const usStore = useStore(); //'. n

    return (
        <Menu inverted fixed='top'>
            <Container>
                {/* <Menu.Item header> */}
                <Menu.Item header as={NavLink} to='/' >
                    <img src="/assets/logo.png" alt="logo" style={{marginRight: '10px'}} />
                    {usStore.commonStore.appDisplayName}
                </Menu.Item>

                {usStore.userStore.isLoggedIn &&
                    <>
                        {/* <Menu.Item name='Activities' /> */}
                        <Menu.Item name='Activities' as={NavLink} to='/activities' />
                        {/* <Menu.Item name='Errors' as={NavLink} to='/errors' /> */}

                        <Menu.Item>
                            {/* <Button positive content='Create Activity' onClick={openForm} /> */}
                            {/* <Button positive content='Create Activity' onClick={() => usStore.activityStore.formOpen()} /> */}
                            <Button positive content='Create Activity' as={NavLink} to='/createActivity' />
                            {/* <span className="btn btn-primary m-2" style={{fontSize: 12, }} >Ash test span</span>
                            <button  className="btn btn-primary btn-sm " style={styles} >Ash test bootstrap button </button> */}
                        </Menu.Item>

                        <Menu.Item name='Portfolio' href='https://ashrafqasem.netlify.app/' target='_blank' >
                            <Icon name="github" size="big" />
                        </Menu.Item>
                            
                        {/* {isLoggedIn ? (
                            <Menu.Item position='right' >
                                <Image src={usStore.userStore.user?.image || '/assets/user.png'} avatar spaced='right' />
                                <Dropdown pointing='top left' text={usStore.userStore.user?.displayName} >
                                    <Dropdown.Menu>
                                        <Dropdown.Item text='My Profile' icon='user' as={Link} to={`/profiles/${usStore.userStore.user?.userName}`} />
                                        <Dropdown.Item text='Logout' icon='power' onClick={logout} />
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Menu.Item>
                        ) : (
                            <Menu.Item position='right' >
                                <Image src={'/assets/user.png'} avatar spaced='right' />
                                <Menu.Item>
                                    <Button positive content='Login' as={NavLink} to='/login' />
                                </Menu.Item>
                            </Menu.Item>
                        )} */}

                        <Menu.Item position='right' >
                            <Image src={usStore.userStore.user?.image || '/assets/user.png'} avatar spaced='right' />
                            <Dropdown pointing='top left' text={usStore.userStore.user?.displayName} >
                                <Dropdown.Menu>
                                    <Dropdown.Item text='My Profile' icon='user' as={Link} to={`/profiles/${usStore.userStore.user?.userName}`} />
                                    <Dropdown.Item text='Logout' icon='power' onClick={usStore.userStore.logout} />
                                </Dropdown.Menu>
                            </Dropdown>
                        </Menu.Item>

                    </>
                }

            </Container>
        </Menu>

    )
})